import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { config } from '../../../../config';
import {
  planOptions,
  ModeratedSettingsFormatted,
  customerTypeOptions,
} from './constants';

import {
  ButtonLink,
  ReactDatePicker,
  Dropdown,
  LastCellContentWrapper,
  Link,
  Status,
  Table,
  Text,
} from './styles';

const CustomTable = (props) => {
  const {
    companies,
    onChangeCustomerType,
    onChangePlan,
    onChangeRenewalDate,
    onChangeStartContractDate,
    onOpenUsersModal,
    onOpenPrepaidBalanceModal,
    onOpenModeratedSettingsModal,
    onOpenTotalAmountModal,
  } = props;

  const handleOpenPastTesters = (companyId) => {
    window.open(`${config.REACT_APP_ADMIN_PLATFORM_URI}/past-testers/${companyId}`);
  };

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <Text.Bold>Workspace Name</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>ID</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Users</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Past Testers</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Plan</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Prepaid Balance</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Moderated Settings</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Customer Type</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Contract Start Date</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Renewal Date</Text.Bold>
          </Table.HeaderCell>
          <Table.HeaderCell>
            <Text.Bold>Total Amount</Text.Bold>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {_.map(companies, (company) => {
          const {
            id,
            name,
            plan,
            prepaidBalance,
            userEligibilityCount,
            companyMembers,
            companyMembersCount,
            moderatedSettings,
            stripeCustomerId,
            customerType,
            contractStartDate,
            renewalDate,
            totalAmountFormatted,
          } = company;

          const formattedContractStartDate = contractStartDate ? new Date(contractStartDate) : null;
          const formattedRenewalDate = renewalDate ? new Date(renewalDate) : null;

          return (
            <Table.Row key={id}>
              <Table.Cell>
                <Text>{name}</Text>
              </Table.Cell>
              <Table.Cell>
                <Text>{stripeCustomerId}</Text>
              </Table.Cell>
              <Table.Cell>
                <Link onClick={() => onOpenUsersModal(companyMembers)}>
                  {companyMembersCount}
                </Link>
              </Table.Cell>

              <Table.Cell>
                <Link onClick={() => handleOpenPastTesters(id)}>
                  {userEligibilityCount}
                </Link>
              </Table.Cell>

              <Table.Cell>
                <Dropdown
                  onChange={(e, { value }) => onChangePlan(id, value)}
                  options={planOptions}
                  selection
                  value={plan}
                />
              </Table.Cell>

              <Table.Cell>
                <Status>
                  <Text>{prepaidBalance}</Text>
                  <Link onClick={() => onOpenPrepaidBalanceModal(company)}>
                    Change
                  </Link>
                </Status>
              </Table.Cell>

              <Table.Cell>
                <Status>
                  <Text>{ModeratedSettingsFormatted[moderatedSettings]}</Text>
                  <Link onClick={() => onOpenModeratedSettingsModal(company)}>
                    Edit
                  </Link>
                </Status>
              </Table.Cell>

              <Table.Cell>
                <Dropdown
                  onChange={(e, { value }) => onChangeCustomerType(id, value)}
                  options={customerTypeOptions}
                  selection
                  value={customerType}
                />
              </Table.Cell>

              <Table.Cell>
                <ReactDatePicker
                  name="startDate"
                  selected={formattedContractStartDate}
                  onChange={(date) => onChangeStartContractDate(id, date)}
                  value={formattedContractStartDate}
                  isClearable
                />
              </Table.Cell>

              <Table.Cell>
                <ReactDatePicker
                  name="renewalDate"
                  selected={formattedRenewalDate}
                  onChange={(date) => onChangeRenewalDate(id, date)}
                  value={formattedRenewalDate}
                  isClearable
                />
              </Table.Cell>

              <Table.Cell>
                <LastCellContentWrapper>
                  {totalAmountFormatted}
                  <ButtonLink onClick={() => onOpenTotalAmountModal(company)}>
                    Change
                  </ButtonLink>
                </LastCellContentWrapper>
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

CustomTable.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      companyMembersCount: PropTypes.number,
      companyMembers: PropTypes.arrayOf(PropTypes.object),
      name: PropTypes.string,
      plan: PropTypes.string,
      prepaidBalance: PropTypes.string,
      pastTestersCount: PropTypes.number,
    }).isRequired,
  ).isRequired,
  onChangeCustomerType: PropTypes.func.isRequired,
  onChangePlan: PropTypes.func.isRequired,
  onChangeRenewalDate: PropTypes.func.isRequired,
  onChangeStartContractDate: PropTypes.func.isRequired,
  onOpenUsersModal: PropTypes.func.isRequired,
  onOpenPrepaidBalanceModal: PropTypes.func.isRequired,
  onOpenModeratedSettingsModal: PropTypes.func.isRequired,
  onOpenTotalAmountModal: PropTypes.func.isRequired,
};

export default CustomTable;
